import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import firebaseAuth from './firebase-auth';
import { AuthUser, AuthProvider } from './use-auth';

const useAuthState = () => {
    const [user, setUser] = useState<AuthUser | null>(
        firebaseAuth.currentUser as AuthUser,
    );
    const [loading, setLoading] = useState<boolean>(true);
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(
            firebaseAuth,
            async (currentUser) => {
                const _isAuthenticated = !!currentUser;
                const [given_name, family_name] = (
                    currentUser?.displayName || ''
                ).split(' ');
                setUser(
                    _isAuthenticated
                        ? {
                              ...currentUser,
                              provider: currentUser.providerData[0]
                                  .providerId as AuthProvider,
                              given_name,
                              family_name,
                              picture: currentUser.photoURL,
                          }
                        : null,
                );
                setLoading(false);
                setIsAuthenticated(_isAuthenticated);
            },
        );

        return () => unsubscribe();
    }, []);

    return { user, loading, isAuthenticated };
};

export default useAuthState;
